(function (location) {
(() => {
  let pending;
  const url = value => {
    try { const u = new URL(value, location.origin); return /^https?:$/.test(u.protocol) ? u.href : ''; } catch { return ''; }
  };
  function resolve(raw) {
    if (!raw || !raw.base || typeof raw.base.id !== 'string') return null;
    const p = {...raw.base, key:raw.key};
    for (const key of ['name','summary','city','url','image']) if (typeof raw[key] === 'string') p[key] = raw[key];
    if (!url(p.url)) return null;
    p.image = p.image && url(p.image) || '';
    p.heroImage = p.image;
    p.position = Array.isArray(p.position) && p.position.length === 2 && p.position.every(Number.isFinite) && Math.abs(p.position[0]) <= 180 && Math.abs(p.position[1]) <= 90 ? p.position : null;
    p.urls = [...new Set([p.url,...(p.urls || [])])];
    p.resources = (p.resources || []).map(r => r.url === p.url ? {...r,title:p.name} : r);
    if (!p.resources.length) p.resources = [{url:p.url,title:p.name,group:'guides'}];
    p.layers = Array.isArray(p.layers) ? p.layers : [];
    p.contentName = raw.contentName;
    p.restaurant = raw.restaurant;
    p.restaurantStatus = raw.restaurantStatus;
    p.meals = raw.meals || [];
    return p;
  }
  async function load() {
    const records = [], seen = new Set();
    const readPage = async (page, param = 'page') => {
      const u = new URL('/pages/coachella-valley-atlas',location.origin);
      u.searchParams.set('view','doi-places');
      u.searchParams.set(param,String(page));
      const preview = new URL(location.href).searchParams.get('preview_theme_id') || (window.Shopify?.theme?.role !== 'main' && window.Shopify?.theme?.id);
      if (preview) u.searchParams.set('preview_theme_id',preview);
      const response = await fetch(u,{credentials:'same-origin',signal:AbortSignal.timeout(20000)});
      if (!response.ok) throw Error('Place records unavailable');
      const data = await response.json();
      if (data.version !== 1 || data.page !== page || !Array.isArray(data.records) || !Number.isInteger(data.pages) || data.pages < 1 || data.pages > 100 || !/^page(?:_[a-zA-Z0-9]+)?$/.test(data.param)) throw Error('Invalid place records');
      return data;
    };
    const first = await readPage(1);
    const responses = [first];
    let next = 2;
    const worker = async () => {
      while (next <= first.pages) {
        const page = next++;
        const data = await readPage(page, first.param);
        if (data.pages !== first.pages || data.param !== first.param) throw Error('Place directory changed during loading');
        responses[page - 1] = data;
      }
    };
    await Promise.all(Array.from({length: Math.min(4, first.pages - 1)}, worker));
    for (const data of responses) {
      for (const raw of data.records) {
        const p = resolve(raw);
        if (p && !seen.has(p.key)) { seen.add(p.key); records.push(p); }
      }
    }
    if (!records.length) throw Error('Empty place records');
    return records;
  }
  function trip(p) {
    if (p.trip) return {...p.trip,name:p.name,city:p.city,url:p.url,image:p.image,lat:p.position?.[1] ?? null,lon:p.position?.[0] ?? null};
    if (!p.restaurant || p.restaurantStatus !== 'listed') return null;
    const zones = {'Palm Springs':0,'Desert Hot Springs':0,'Cathedral City':0,'Rancho Mirage':1,'Palm Desert':1,'Indian Wells':2,'La Quinta':2,'Indio':3,'Coachella':3};
    return {id:p.id,name:p.name,city:p.city,url:p.url,image:p.image,zone:zones[p.city] ?? 1,tags:['food'],minutes:90,exposure:'mixed',note:p.summary,kind:'food',meals:p.meals,query:p.name+', '+p.city+', California',lat:p.position?.[1] ?? null,lon:p.position?.[0] ?? null,scheduled:false};
  }
  window.DoiPlaces = {resolve,trip,load:() => pending ||= load().catch(error => { pending = null; throw error; })};
  window.dispatchEvent(new Event('doi:places-ready'));
})();

})(globalThis.DOIEmbeddedContext?.location || globalThis.location);
